import { getJson } from 'utils/http';

import { CmsApiPage } from './types/CmsApiPage';

export function fetchCmsApiPage(pageUrl: string): Promise<{
  data: CmsApiPage;
  type: string;
}> {
  return getJson(`/data/website/contents/${pageUrl}`);
}
